import { isAiConfigured } from '@/ai/provider';
import type { AiProviderKind, AiSettings } from '@/domain/types';
import { AI } from '../strings';
import { useSettings } from './useSettings';

export interface AiStatus {
  configured: boolean;
  provider: AiProviderKind;
  providerLabel: string;
  model: string;
  /** Pill text. */
  label: string;
  settings: AiSettings | undefined;
}

export function deriveAiStatus(ai: AiSettings | undefined): AiStatus {
  const provider = ai?.provider ?? 'gemini';
  const providerLabel = AI.providerLabel[provider];
  const configured = ai ? isAiConfigured(ai) : false;
  return {
    configured,
    provider,
    providerLabel,
    model: ai?.model ?? '',
    label: configured ? AI.connected(providerLabel) : AI.notConnected,
    settings: ai,
  };
}

/** AI pill state from `settings.ai`. */
export function useAiStatus(): AiStatus {
  const settings = useSettings();
  return deriveAiStatus(settings?.ai);
}
